/* eslint-disable @typescript-eslint/no-explicit-any */
import { Capacitor } from '@capacitor/core';
import { StatusBarModule } from './status-bar.module';
import { StatusBarService } from './status-bar.service';

export function StatusBar(color: string): ClassDecorator {
  return function (target: any) {
    const originalMethod = target.prototype.ionViewWillEnter;

    target.prototype.ionViewWillEnter = async function (...args: any) {
      if (!Capacitor.isPluginAvailable('StatusBar')) return;

      const statusBarService = StatusBarModule.injector.get(StatusBarService);
      await statusBarService.setBackgroundColor(color);

      originalMethod?.apply(this, args);
    };
  };
}
